import React from "react";
import styled from "styled-components";
import colors from "./colors";
import LazyLoad from "react-lazyload";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Icon from "../icon/Icon";

const Card = styled.div`
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-grow: 1;
  flex-basis: 320px;
  flex-direction: column;
  border: 1px solid ${colors.BORDER_COLOR};
  background: white;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 2rem;
  box-shadow: 0 1px 8px 0 rgba(0,0,0,0.13);
  min-height: calc(100% - 2rem);
  position: relative;
  .card__anchor{
    position: relative
  }
  &.slider-card{
    height: 100%;
    width: auto;
    max-width: unset;
    margin: 0 1rem;
  }
  ${({clickable}) => clickable && `
    cursor: pointer;
  `}
  
  ${({fluid}) => fluid && `
    max-width: unset;
    flex-basis: 100%;
  `}
  &:before{
      visibility: hidden;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
      background: ${props => props.theme.CardHightlightColor};
      height: 10px;
      opacity: 0;
      ${({active}) => active && `
        visibility: visible;
        z-index: 1;
        opacity: 1;
      `}
    }
    &:hover{
      &:before{
        ${({activeOnHover}) => activeOnHover && `
          visibility: visible;
          z-index: 1;
          height: 10px;
          opacity: 1;
        `}
      }
    }
`;


const Figure = styled.figure`
  background-color: ${colors.GRAY_ULTRA_LIGHT};
  background-repeat: no-repeat;
  ${props =>
    props.src &&
    `
    background-image: url(${props.src});
    background-position: 50% 50%;
    background-size: cover;
  `}
  width: 100%;
  height: 152px;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;

  &.fade-appear {
    opacity: 0;
    &.fade-appear-active {
      opacity: 1;
      transition: opacity 0.35s ease-in-out;
    }
  }
`;

const CardImage = styled(({ src, ...rest }) => {
  return (
    <LazyLoad height={160} once>
      <ReactCSSTransitionGroup
        key="1"
        transitionName="fade"
        transitionAppear={true}
        transitionAppearTimeout={350}
        transitionEnter={false}
        transitionLeave={false}
      >
        <Figure src={src} {...rest} />
      </ReactCSSTransitionGroup>
    </LazyLoad>
  );
})`
`;


const Image = styled(({ src, ...rest }) => <Figure src={src} {...rest} />)``;

const CardContent = styled.div`
  padding: 1.25rem;
  line-height: 1.25rem;

  > * {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const CardHeader = styled.h5`
  font-size: ${18 / 16}rem;
  line-height: ${23 / 16}rem;
  color: ${colors.GRAY_DARK};
  margin-top: 0;
  margin-bottom: 4px;
  font-weight: 500;
  a{
    color: inherit;
    &:hover{
      text-decoration: underline;
    }
  }
`;

const CardBody = styled.p`
  color: ${colors.GRAY_DARK}
  line-height: 1.35em;
  margin: 0;
  svg {
    width: 1.3125em;
    height: 1.3125em;
    fill: ${colors.BRAND_GREEN};
    margin-right: .25em;
  }

  strong { font-weight: bold; }
  small { font-size: 0.75rem; color: #9f9f9f; }
`;

const CardLineSeparator = styled.span`
  display: block;
  height: 1px;
  background: ${colors.GRAY_ULTRA_LIGHT};
`;

const CardSectionBreak = styled.span`
  display: block;
  height: 1rem;
`;

const CardReadMore = styled.span`
  display: block;
  font-weight: bold;
  // margin-top: 1em;

  > a {
    font-size: ${14 / 16}rem;
    padding: ${12 / 16}rem 1rem;
    display: block;
    color: inherit;
    text-transform: uppercase;
    text-align: center;
    background: rgba(65, 117, 5, 0.12);
    border: 1px solid rgba(65, 117, 5, 0.22);
    border-radius: 3.24px;
    color: ${colors.BRAND_GREEN};
    .current-input-touch & {
      &:active:not([disabled]) {
        color: white;
        background: ${colors.BRAND_GREEN};
      }
    }

    .current-input-mouse & {
      &:hover:not([disabled]) {
        color: white;
        background: ${colors.BRAND_GREEN};
      }
    }

    > i {
      display: none;
      vertical-align: bottom;
      line-height: 1em;
      font-size: 1.15em;
      font-weight: inherit;
    }
    /*
    &:hover {
      background: rgba(65,117,5,0.22);
      border: 1px solid rgba(65,117,5,0.42);
    }
    */
  }
`;

const CardCantBeBooked = styled.span`
  display: block;
  font-weight: bold;
  font-size: ${14 / 16}rem;
  padding: ${12 / 16}rem 1rem;
  text-transform: uppercase;
  text-align: center;
  background: ${colors.GRAY_ULTRA_LIGHT};
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: 3.24px;
`;

const CardDescriptionText = styled.span`
  display: block;
  font-size: ${15 / 16}rem;
  margin-bottom: 1rem;
  color: #34404a;
  line-height: ${22.5 / 16}rem;
`;

const CardTopTitle = styled.span`
  display: block;
  font-size: ${14 / 16}rem;
  line-height: 2.5rem;
  color: #34404a;
  text-transform: uppercase;
  text-align: center;
  color: ${colors.BRAND_GREEN};
  font-family: 'Roboto', 'Helvetica Neue', 'Helvetica', sans-serif;
  font-weight: bold;
  
  svg {
    fill: transparent;
    stroke: ${colors.BRAND_GREEN};
    width: 17px;
    height: 17px;
    margin-right: 4px;
    vertical-align: text-bottom;
    stroke-width: 2px;
  }
`;

const CardInfoWithIconWrap = styled.span`
  display: flex;
  align-items: center;

  span {
    font-size: ${15 / 16}rem;
    flex: 1;
    line-height: ${22 / 16}rem;
  }

  svg {
    width: 14px;
    height: 18px;
    margin-right: 8px;
    fill: none;
    stroke: currentColor;
  }
`;

const CardPrice = styled.span`
  position: absolute;
  right: 0;
  bottom: 0;
  background: ${props => props.theme.CardPriceBackground};
  color: white;
  padding: 10px 15px;
  border-top-left-radius: 3px;
  ${({disabled}) => disabled && `
    background: ${colors.BORDER_COLOR};
    color: #515151;
  `}
`

const DiscountBadge = styled.span`
  position: absolute;
  right: 15px;
  top: 15px;
  height: 72px;
  width: 72px;
  color: white;
  transform: rotate(15deg);
  display: flex;
  align-items: center;
  font-size: 24px;
  line-height: 18px;
  text-align: center;
  small{
    font-size: 10px;
  }
  svg{
    position: absolute;
    top: 0;
    left: 0;
  }
  .discount--text{
    margin-top: -10px;
    position: relative;
    display: block;
    width: 100%;
  }
`

const CardAuthor = styled.div`
  border-top: 1px solid ${colors.BORDER_COLOR};
  display: flex;
  padding: 1.25rem;
  line-height: 1.3125;
  font-size: 0.9375rem;
  align-items: center;
  margin-top: auto;
  pointer-events: none;
  .card--author-image{
    height: 50px;
    width: 50px;
    min-width: 50px;
    max-width: 50px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: ${colors.GRAY_MEGA_LIGHT};
    border-radius: 50%;
    margin-right: 10px;
  }
  .card--author-name{
    font-weight: 500;
    color: ${colors.GRAY_DARK};
  }
`


class CardInfoWithIcon extends React.Component {
  render() {
    const { children, icon } = this.props;

    return (
      <CardInfoWithIconWrap>
        {Boolean(icon) && <Icon icon={icon} />}
        <span>{children}</span>
      </CardInfoWithIconWrap>
    );
  }
}

export {
  Card,
  CardImage,
  CardContent,
  CardHeader,
  CardBody,
  CardReadMore,
  CardSectionBreak,
  CardLineSeparator,
  CardDescriptionText,
  CardTopTitle,
  CardInfoWithIcon,
  Figure,
  CardCantBeBooked,
  CardPrice,
  CardAuthor,
  Image,
  DiscountBadge,
};



// WEBPACK FOOTER //
// ./src/modules/common/components/ui/Card.js